import { SubscriptionTier } from '@/actions/dtos/subscription';
import { useState } from 'react';

const useTierNavigation = () => {
  const [currentTier, setCurrentTier] = useState(0);

  const handlePrevTier = () => {
    setCurrentTier((prevTier) => (prevTier === 0 ? 0 : prevTier - 1));
  };

  const handleNextTier = () => {
    const maxTierIndex = Object.values(SubscriptionTier).length - 1;
    setCurrentTier((prevTier) => (prevTier >= maxTierIndex ? prevTier : prevTier + 1));
  };

  return {
    currentTier,
    handlePrevTier,
    handleNextTier,
  };
};

export default useTierNavigation;
